import React from 'react'

const SellingRoute = () => {
  return (
    <div>SellingRoute</div>
  )
}

export default SellingRoute